import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFolderEmptySizeS from './IconFolderEmpty_size_s';

const props: CreateIconArguments = {
  l: IconFolderEmptySizeS,
  m: IconFolderEmptySizeS,
  s: IconFolderEmptySizeS,
  xs: IconFolderEmptySizeS,
  name: 'IconFolderEmpty',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
